enum Resources {
    PRODUCTS = "products",
    TRANSPORTS = "transports",
    PAYMENTS = "payments",
    PRODUCTION_PLANS = "production_plans",
    PROTOCOLS = "protocols",
    STOCK_ITEMS = "stock_items",
    EMPLOYEES = "apps/employees",
    PICK_ORDERS = "apps/pick_orders",
    PICK_CONTAINERS = "apps/pick_containers",
    PICK_ITEMS = "apps/pick_items",
    COMPLETION_ITEMS = "apps/pick_containers/completion_items",
    VATS = "vats",
}

export default Resources;
